// extracted by mini-css-extract-plugin
module.exports = {"video":"VideoThumbnail_video__LoVks","thumbnail":"VideoThumbnail_thumbnail__RNLqP"};